// test2376
(2376 && 0);
